/* KFH search page: live suggestions under the search box (Shopify's /search/suggest).
   Only products that name every typed word are listed, the same rule as the results page. */
(() => {
  const form = document.querySelector('[data-kfh-suggest]');
  if (!form || form.dataset.ready) return;
  form.dataset.ready = '1';
  const input = form.querySelector('input[name="q"]');
  const box = document.createElement('div');
  box.className = 'kfh-suggest';
  box.id = 'KfhSuggest';
  box.hidden = true;
  form.appendChild(box);
  input.setAttribute('aria-controls', box.id);
  input.setAttribute('aria-autocomplete', 'list');
  // Opened from the header search icon: type straight away (backs up autofocus, which some browsers skip on back/forward).
  if (input.hasAttribute('autofocus') && !input.value && document.activeElement !== input) input.focus({ preventScroll: true });

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const esc = (t) => String(t).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const stem = (w) => (w.length > 3 && w.endsWith('s') ? w.slice(0, -1) : w);
  const money = (dollars) => {
    const cents = Math.round(parseFloat(dollars) * 100);
    return window.KFH && window.KFH.money ? window.KFH.money(cents) : `$${(cents / 100).toFixed(0)}`;
  };
  const sized = (u) => (u ? u + (u.includes('?') ? '&' : '?') + 'width=96' : '');
  let timer;
  let ctrl;

  const run = async () => {
    const q = input.value.trim();
    if (q.length < 2) { box.hidden = true; return; }
    if (ctrl) ctrl.abort();
    ctrl = new AbortController();
    try {
      const res = await fetch(`${root}search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=10`, { signal: ctrl.signal });
      const data = await res.json();
      const words = q.toLowerCase().split(/\s+/).filter((w) => w.length > 1);
      const list = ((data.resources && data.resources.results.products) || []).filter((p) => {
        const hay = [p.title, p.type, (p.tags || []).join(' ')].join(' ').toLowerCase();
        return words.every((w) => hay.includes(stem(w)));
      }).slice(0, 6);
      if (!list.length || input.value.trim() !== q) { box.hidden = true; return; }
      const from = (p) => (p.price_min && p.price_max && p.price_min !== p.price_max ? 'From ' : '');
      box.innerHTML = list.map((p) => `<a class="kfh-suggest__item" href="${esc(p.url)}">${p.image ? `<img src="${esc(sized(p.image))}" alt="" width="44" height="44" loading="lazy">` : ''}<span>${esc(p.title)}</span><b>${from(p)}${money(p.price_min || p.price)}</b></a>`).join('')
        + `<button type="submit" class="kfh-suggest__all">${esc(form.dataset.seeAll || 'See all results')}</button>`;
      box.hidden = false;
    } catch (e) { /* aborted or offline: keep the plain search */ }
  };

  input.addEventListener('input', () => { clearTimeout(timer); timer = setTimeout(run, 200); });
  input.addEventListener('keydown', (e) => { if (e.key === 'Escape') box.hidden = true; });
  document.addEventListener('click', (e) => { if (!form.contains(e.target)) box.hidden = true; });
})();
